import SafeArea from "@/components/safe-area";
import StatusBarHeight from "@/components/status-bar-height";
import NavigationBar from "@/containers/common/NavigationBar";
import { BridgeCallHandlers } from "@/interfaces/enums";
import bridge from "@/utils/dsBridge";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "next-i18next";
import React from "react";
interface Props {
	leadingNode?: React.ReactNode;
	onRuleClick?: () => void;
}
export default function StockNavigation({ leadingNode, onRuleClick }: Props) {
	const { t } = useTranslation("activities");

	const handleClose = () => {
		bridge.call(BridgeCallHandlers.ON_CLOSE_WEB_PAGE);
	};

	return (
		<div className="pl-4">
			<StatusBarHeight />
			<SafeArea position="top" />
			<NavigationBar
				leading={leadingNode ? leadingNode : <CloseBtn onClick={handleClose} />}
				title=""
				actions={[<RuleBtn key="rule" text={t("promotionDetails")} onClick={() => onRuleClick && onRuleClick()} />]}
			/>
		</div>
	);
}

function CloseBtn({ onClick }: { onClick: () => void }) {
	return (
		<a
			id="close"
			className="flex h-9 w-9 items-center justify-center rounded-full bg-[#5A3783] text-white"
			onClick={onClick}
		>
			<ChevronLeft size={24} />
		</a>
	);
}

function RuleBtn({ onClick, text }: { text: string; onClick: () => void }) {
	return (
		<a
			id="rule"
			className="flex items-center justify-center rounded-l-3xl bg-[#5A3783] px-4 text-sm font-medium text-white pt-[1px] pb-[4px]"
			onClick={onClick}
		>
			{text}
		</a>
	);
}
